<div class="breadcrumb">
  <ul>
    @for (breadcrumb of breadcrumbs; track $index) {
      <li>
        @if (!breadcrumb.link) {
          {{ breadcrumb.title }}
        }
        @if (breadcrumb.link) {
          <a class="text-link" [routerLink]="breadcrumb.link">{{ breadcrumb.title }}</a>
        }
      </li>
    }
  </ul>
</div>
